import React from 'react'
import { useTranslation } from 'react-i18next'
import { getInsightContentTypeDisplayText } from 'components/insightContent/utils/utils'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
// @ts-ignore
import { Dialog } from '@netbasequid/core'
import AccordionSectionType from 'components/insightContent/enum/AccordionSectionType'
import { InsightContentSettingType } from 'components/insightContent/types'
import AccordionGroup from 'components/insightContent/visualization/AccordionGroup'
import InsightContentType from 'components/insightContent/enum/InsightContentType'
import { sendTypedMessage } from 'utils/iframeUtil'
import { toExternal } from 'vo/util'
import { TopInfoBox, TopInfoRight } from 'components/insightContent/visualization/InfoBox/index.css'
import GoToAnalysisButton from 'components/insightContent/visualization/GoToAnalysisButton'
import InsightDialog from 'components/insightContent/visualization/InsightDialog'
import { AutomationId } from 'utils/automationUtil'

const DIALOG_CONTENT_HEIGHT = '460px'

const InsightModal = ({
  open,
  title,
  onClose,
  detailSetting,
  widgetSettingWithSelection
}: {
  open: boolean
  title: string | undefined
  onClose: () => void
  detailSetting: InsightContentSettingType | undefined
  widgetSettingWithSelection?: any
}) => {
  const theme = useDisplayTheme() as Theme
  const { t } = useTranslation()

  function goToAnalysis() {
    sendTypedMessage('goToAnalysis', toExternal(widgetSettingWithSelection))
  }

  return (
    <InsightDialog open={open} onClose={onClose}>
      <Dialog.DialogTitle>{title}</Dialog.DialogTitle>
      <TopInfoBox mode={theme} data-testid={AutomationId.insightModal.selectedTerm}>
        {t('selectedPost')}
        <TopInfoRight>
          <GoToAnalysisButton onClick={() => goToAnalysis()} />
        </TopInfoRight>
      </TopInfoBox>
      <Dialog.DialogContent height={DIALOG_CONTENT_HEIGHT}>
        <AccordionGroup
          insightContentsConfig={[
            {
              accordionTitle: getInsightContentTypeDisplayText(AccordionSectionType.TOP_AUTHOR),
              accordionContents: [
                {
                  insightContentType: InsightContentType.REPOSTS,
                  detailSetting
                },
                {
                  insightContentType: InsightContentType.REPLIES,
                  detailSetting
                }
              ]
            },
            {
              accordionTitle: getInsightContentTypeDisplayText(AccordionSectionType.COMMENT),
              accordionContents: [
                {
                  insightContentType: InsightContentType.COMMENT,
                  detailSetting
                }
              ]
            }
          ]}
        />
      </Dialog.DialogContent>
      <Dialog.DialogActions />
    </InsightDialog>
  )
}

export default InsightModal
